// import { clearParseAndGenerateServicesCalls } from "@typescript-eslint/typescript-estree/dist/parser"
import { FilterTypesEnum } from '../../../../models/FilterTypesEnum';
import { useEffect, useState } from 'react'
import classes from './Search.module.css'
import { useSelector } from "react-redux";
import { onKeyDown } from '../../../../service';


const Search = ({ filtercb, filters }) => {
    const { direction, texts } = useSelector(state => state.translate);
    const [filtersInputs, setFilterInputs] = useState();
    const [showChildren, setShowChildren] = useState()

    useEffect(() => {
        setFilterInputs(filters.reduce((inputs, filter) => {
            inputs[filter.name] = [];
            return inputs
        }, {}))
        setShowChildren(filters.map(() => false))
    }, [])
    const handleChangeInputsFreeType = (event) => {
        setFilterInputs(prevFilterInputs => {
            const newFilterInputs = { ...prevFilterInputs }
            newFilterInputs[event.target.name] = event.target.value;
            filtercb(newFilterInputs);
            return newFilterInputs;
        });
    }

    const handleChangeInputs = (filter, value) => {
        if (!filtersInputs[filter.name].includes(value)) {
            setFilterInputs(prevFilterInputs => {
                const newFilterInputs = { ...prevFilterInputs }
                newFilterInputs[filter.name] && newFilterInputs[filter.name].push(value);
                filtercb(newFilterInputs);
                return newFilterInputs;
            });
        }
        else {
            const index = filtersInputs[filter.name].indexOf(value);
            setFilterInputs(prevFilterInputs => {
                const newFilterInputs = { ...prevFilterInputs }
                filtersInputs[filter.name].splice(index, 1);
                filtercb(newFilterInputs);
                return newFilterInputs;
            });
        }

    }
    const handleCollapse = (i) => {
        let newArr = [...showChildren]
        newArr[i] = !newArr[i]
        setShowChildren(newArr)
    }

    function clearAllFields() {
        setFilterInputs(filters.reduce((inputs, filter) => {
            inputs[filter.name] = [];
            return inputs
        }, {}));
        filtercb(filters.reduce((inputs, filter) => {
            inputs[filter.name] = [];
            return inputs
        }, {}))
    }

    function FiltersTypes(filter, i) {
        switch (filter.type) {
            case FilterTypesEnum.free:
                return (<div key={i} className={classes.WrapInput}>
                    <input type='text' name="free" className={classes.Input} onChange={(e) => handleChangeInputsFreeType(e)} value={filtersInputs[filter.name]}>
                    </input>
                    <div className={classes.FilterIcon}></div>
                </div>)
            case FilterTypesEnum.values:
                return (<div key={i} className={classes.WrapSelect}>
                    <div className={classes.FilterType} onClick={() => handleCollapse(i)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCollapse(i))}>
                        <div className={classes.FilterName}>{filter.text}</div>
                        <div className={` ${showChildren[i] ? classes.OpenIcon : classes.CollapsedIcon}`}></div>
                    </div>
                    {showChildren && showChildren[i] && filter.values && filter.values.map(item =>
                        <div key={item} className={`${classes.SearchByItem} ${filtersInputs[filter.name].includes(item) ? classes.Select : ``}`} onClick={(e) => handleChangeInputs(filter, item)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleChangeInputs(filter, item))}>{`${(filter.name != "ideId" && filter.name != "ide") ? texts[item] : texts.ides.find(x => x.id === item).name}`}</div>)}
                </div>)
            default:
                return null
        }
    }

    return (
        <>
            <div className={`${classes[direction]} ${classes.SearchPopUp}`} >
                <div className={classes.ClearText} onClick={clearAllFields} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clearAllFields)}>{texts.Clear}</div>
                {
                    filtersInputs && filters.map((filter, i) => FiltersTypes(filter, i))
                }
            </div>
        </>
    )
}

export default Search